import { useNavigate } from 'react-router-dom'
import { BsClock } from 'react-icons/bs'
import { articleType } from '../article'
import { Tag } from '../extra/Tag'
import { AuthorTag } from '../extra/AuthorTag'

export const LatestArticleCard = (props: articleType) => {
  const navigate = useNavigate()

  const route = () => {
    navigate(`/articles/${props.id}`)
  }

  return (
    <div
      onClick={route}
      className='flex flex-col max-w-[420px] gap-3 p-5 bg-white cursor-pointer rounded-lg shadow-equal-all-sides'
    >
      <div className='flex flex-wrap gap-3'>
        {props.tags?.map((tag, idx) => (
          <Tag
            key={tag + idx}
            text={tag}
            className='lg:font-medium text-xs px-[6px] py-[2px]'
          />
        ))}
      </div>

      <h3 className='font-medium text-sm lg:text-base cursor-pointer'>
        {props.title}
      </h3>

      <div className='flex items-center gap-3'>
        <AuthorTag
          author={props.author}
          pictureDimension='w-6 h-6 lg:w-8 lg:h-8'
          userNameClassName='text-[10px] lg:text-base lg:font-medium'
          occupationClassName='text-[8px] lg:text-xs lg:font-medium'
        />
        <span className='border-x-[1px] border-y-[10px] border-[#9FCDD7]' />
        <div className='flex items-center gap-[8px] text-[#A0ABBE]'>
          <BsClock className='' />
          <span className='text-xs lg:text-base'>3 min to read</span>
        </div>
      </div>
    </div>
  )
}
